module.exports = __webpack_public_path__ + "img/pHD_T-5000.747b0f5e.webp";